<template>
    <b-card class="mb-2" header-tag="header">
        <template #header>
            <h6 class="mb-0 text-center"><i class="fa fa-car"></i> Datos de Financiación</h6>
        </template>
        <b-row>
            <b-col md="6">
                <div class="form-group">
                    <label for="">Vehiculo</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="MARCA LINEA VERSIÓN"
                        disabled
                    />
                </div>
            </b-col>
            <b-col>
                <div class="form-group">
                    <label for="">Modelo</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                        disabled
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Valor del Vehiculo</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                        disabled
                    />
                </div>
            </b-col>
            <div class="w-100"></div>
            <b-col md>
                <div class="form-group">
                    <label for="">Cuota Inicial</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Valor a financiar</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Plazo</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                    />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Plan</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder=""
                    />
                </div>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
